<b>{{ cityMap().key }}</b>
@for (value of cityMap().value; track value) {
  <span class="d-block">
    <app-grouped-districts-detail
      [districtGroup]="value"
    ></app-grouped-districts-detail>
  </span>
}
